// Importing
import React from "react";
import Toast, {BaseToast} from "react-native-toast-message";
import {StyleSheet, Text, TouchableOpacity, View} from "react-native";
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import i18n from "../../i18n";

const toastStyles = StyleSheet.create({
    contentContainer: {
        paddingHorizontal: 15,
    },
    successContainer: {
        borderLeftWidth: 5,
        borderLeftColor: "#34c28f",
        height: 65,
        backgroundColor: "#3a3a3c",
    },
    errorContainer: {
        borderLeftWidth: 5,
        borderLeftColor: "#f12d2d",
        height: 65,
        backgroundColor: "#3a3a3c",
    },
    infoContainer: {
        borderLeftWidth: 5,
        borderLeftColor: "#5AC8FA",
        height: 65,
        backgroundColor: "#3a3a3c",
    },
    successHeading: {
        fontSize: 16,
        fontWeight: "500",
        color: "#34c28f",
    },
    errorHeading: {
        fontSize: 16,
        fontWeight: "500",
        color: "#f12d2d",
    },
    infoHeading: {
        fontSize: 16,
        fontWeight: "500",
        color: "#5AC8FA",
    },
    message: {
        fontSize: 12,
        color: "#ffffff",
    },
    trailingIcon: {
        display: "none",
    },
    pendingOrderContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#3a3a3c',
        borderLeftWidth: 5,
        borderLeftColor: '#FF8C00',
        borderRadius: 8,
        paddingVertical: 12,
        paddingLeft: 15,
        paddingRight: 10,
        minHeight: 65,
        width: '90%',
        maxWidth: 500,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.3,
        shadowRadius: 4,
        elevation: 5,
    },
    pendingOrderContent: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
    },
    pendingOrderText: {
        fontSize: 16,
        fontWeight: '500',
        color: '#FF8C00',
        flex: 1,
    },
    closeIconButton: {
        padding: 5,
        marginLeft: 8,
    },
});

// Toast configuration. NOTE: This configuration will be passed via config prop of the Toast reference placed in the App.js file
const ToastConfig = {
    /*
      Overwriting 'success' type,
      modifying the existing `BaseToast` component
    */
    success: ({text1, text2}) => (
        <BaseToast
            style={toastStyles.successContainer}
            contentContainerStyle={toastStyles.contentContainer}
            text1={text1}
            text1Style={toastStyles.successHeading}
            text2={text2}
            text2Style={toastStyles.message}
            trailingIconStyle={toastStyles.trailingIcon}
        />
    ),
    /*
      Overwriting 'error' type,
      modifying the existing `BaseToast` component
    */
    error: ({text1, text2}) => (
        <BaseToast
            style={toastStyles.errorContainer}
            contentContainerStyle={toastStyles.contentContainer}
            text1={text1}
            text1Style={toastStyles.errorHeading}
            text2={text2}
            text2Style={toastStyles.message}
            trailingIconStyle={toastStyles.trailingIcon}
        />
    ),
    /*
      Overwriting 'info' type,
      modifying the existing `BaseToast` component
    */
    info: ({text1, text2}) => (
        <BaseToast
            style={toastStyles.infoContainer}
            contentContainerStyle={toastStyles.contentContainer}
            text1={text1}
            text1Style={toastStyles.infoHeading}
            text2={text2}
            text2Style={toastStyles.message}
            trailingIconStyle={toastStyles.trailingIcon}
        />
    ),
    // Used for incoming online order notifications.
    pendingOrderToast2: ({props}) => (
        <View style={toastStyles.pendingOrderContainer}>
            <View style={toastStyles.pendingOrderContent}>
                <Icon name="bell-ring" size={24} color="#FF8C00" style={{marginRight: 10}} />
                <Text style={toastStyles.pendingOrderText} numberOfLines={3}>
                    {props?.message || i18n.t('toast_pending_online_order')}
                </Text>
            </View>
            <TouchableOpacity
                style={toastStyles.closeIconButton}
                onPress={() => Toast.hide()}
                hitSlop={{top: 10, bottom: 10, left: 10, right: 10}}
            >
                <Icon name="close-circle" size={26} color="#fff" />
            </TouchableOpacity>
        </View>
    ),
};

export default ToastConfig;

